import { render, staticRenderFns } from "./Companynew.vue?vue&type=template&id=0b2bf146&scoped=true"
import script from "./Companynew.vue?vue&type=script&lang=js"
export * from "./Companynew.vue?vue&type=script&lang=js"
import style0 from "./Companynew.vue?vue&type=style&index=0&id=0b2bf146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2bf146",
  null
  
)

export default component.exports